var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pa-0"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"700","src":_vm.dashboard,"frameborder":"0","allowfullscreen":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }